import React from 'react';
import VerifyEmail from '../Auth/VerifyEmail';

const BridgeClubVerifyEmail: React.FC = () => {
  return <VerifyEmail accountType="bridge-club" />;
};

export default BridgeClubVerifyEmail;
